import React from 'react';

import cx from 'classnames';

import { PartnerAgent } from 'api/partnerAgent';
import Divider from 'components/shared/Divider';
import ListItem from 'components/shared/ListItem';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';
import ListItemTitle from './ListItemTitle';

function PartnerAgentList({
  list = [],
  onEdit,
  onDelete,
}: {
  list: PartnerAgent[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}) {
  const isEmpty = list.length === 0;

  return (
    <div>
      <Divider className={s.divider} />

      {/* Empty text */}
      {isEmpty && (
        <div className={s.empty}>
          <Text type="danger" accent>
            No Results Found. Please try again.
          </Text>
        </div>
      )}

      {/* List */}
      {list.map((p) => (
        <PartnerItem key={p.id} p={p} onEdit={onEdit} onDelete={onDelete} canDelete />
      ))}
    </div>
  );
}

export default PartnerAgentList;

export function PartnerItem({
  p,
  onEdit,
  onDelete,
  canDelete,
  status,
  className,
}: {
  p: PartnerAgent;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  canDelete: boolean;
  status?: string;
  className?: string;
}) {
  return (
    <div className={cx(s.listItemWrapper, className)}>
      <ListItem
        isEditing={false}
        className={s.listItemInner}
        title={<ListItemTitle {...p} />}
        onAction={() => onEdit(p.id)}
        status={status}
        canDelete={canDelete}
        onDelete={() => onDelete(p.id)}
      />
    </div>
  );
}
